import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/mapaIN/step2';
import { CTRL_202 } from '../../../validators/202/ctrl202';
import { Description } from '../models/Description';
import { TypeNatureMarcheLot } from '../models/TypeNatureMarcheLot';
import { MapaINControlNames } from '../service/mapaINControleNames';
import { CTRL_268 } from '../../../validators/268/ctrl268';
import { CTRL_203 } from '../../../validators/203/ctrl203';
import { CTRL_204 } from '../../../validators/204/ctrl204';
import { CTRL_205 } from '../../../validators/205/ctrl205';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';

@Component({
  selector: 'app-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss'],
})
export class DescriptionComponent implements OnInit, AfterViewInit {

  @Input() uid = '';
  public current_uid = 'Description';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;

  @Input() description: Description;
  @Input() natureMarche: TypeNatureMarcheLot;
  natureMarche_uid = 'TypeNatureMarcheLot';
  estCbChecked: boolean;
  i: number = 0;
  lieuExecutionCB = '';
  public rg2 = CTRL_268.id + '_2';
  public rg3 = CTRL_268.id + '_3';
  public rg4 = CTRL_268.id + '_4';
  public rg5 = CTRL_202.id + '_1';
  public rg6 = CTRL_203.id + '_2';
  public rg7 = CTRL_204.id + '_3';
  public rg8 = CTRL_205.id + '_4';
  public rg9 = CTRL_202.id + '_5';
  public rg10 = CTRL_203.id + '_6';

  public step2 = new Step2();

  constructor(private avisDataTransferService: AvisDataTransferService) {
  }

  public ngOnInit() {
    this.cbChecked();

  }

  ngAfterViewInit() {
    this.researchFormOnChangeDetecte();
  }

  researchFormOnChangeDetecte() {
    const controlName = this.getUid() + '_SepAtt_lieuExecutionCB';
    const control = this.parentForm.get(controlName);
    if (control) {
      control.valueChanges.subscribe(value => {
        this.cbChecked();
      });
    }
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getUidNatureMarche() {
    return this.uid + '_SepSep_' + this.natureMarche_uid;
  }

  isTravaux() {
    return this.parentForm.controls[this.getUidNatureMarche() + '_SepAtt_travaux']?.value;
  }

  isFournitures() {
    return this.parentForm.controls[this.getUidNatureMarche() + '_SepAtt_fournitures']?.value;
  }

  isServices() {
    return this.parentForm.controls[this.getUidNatureMarche() + '_SepAtt_services']?.value;
  }

  cbChecked() {
    this.i = this.i + 1;
    this.estCbChecked = this.parentForm.controls[this.getUid() + '_SepAtt_lieuExecutionCB'] ?
      this.parentForm.controls[this.getUid() + '_SepAtt_lieuExecutionCB'].value :
      this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.initialFromMAPA.description.isLieuExecutionLivraison;
    if (this.estCbChecked) {
      this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({rgCtrls: this.getCtrl_268_3Names_json()}));
      this.parentForm.addControl(this.getStepId() + this.rg9, new FormControl({rgCtrls: MapaINControlNames.getCtrl_202LieuExecLivraisonNames_json()}));
      this.parentForm.addControl(this.getStepId() + this.rg10, new FormControl({rgCtrls: MapaINControlNames.getCtrl_203LieuExecLivraisonNames_json()}));
    } else {
      this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({rgCtrls: this.getCtrl_268_1Names_json()}));
      this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({rgCtrls: this.getCtrl_268_2Names_json()}));
      this.parentForm.addControl(this.getStepId() + this.rg5, new FormControl({rgCtrls: MapaINControlNames.getCtrl_202Names_json()}));
      this.parentForm.addControl(this.getStepId() + this.rg6, new FormControl({rgCtrls: MapaINControlNames.getCtrl_203Names_json()}));
      this.parentForm.addControl(this.getStepId() + this.rg7, new FormControl({rgCtrls: MapaINControlNames.getCtrl_204Names_json()}));
      this.parentForm.addControl(this.getStepId() + this.rg8, new FormControl({rgCtrls: MapaINControlNames.getCtrl_205Names_json()}));
    }
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf('SepSep'));
  }

  private getCtrl_268_1Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    return {firstChamp: deptPub, secondChamp: cp};
  }

  private getCtrl_268_2Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = 'lieuLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    return {firstChamp: deptPub, secondChamp: cp};
  }

  private getCtrl_268_3Names_json(): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = 'lieuExecutionLivraison_SepSep_Initial_SepSep_Description_SepSep_TypeLieu_SepAtt_cp';
    return {firstChamp: deptPub, secondChamp: cp};
  }

}

